<script>
import { shareRecordService } from '@/src/services/safehaven/ShareRecordsService'

export default {
  props: {
    group: {
      type: Number,
      default: 0,
    },
    recipientInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      shareRecordConfirm: false,
      termsCheck: false,
      recipientName: '',
      recipientEmail: '',
      duration: '',
      snackbar: false,
      snackbarMessage: '',
    }
  },
  computed: {},
  mounted() {
    this.recipientName = this.recipientInfo.recipient_name
    this.recipientEmail = this.recipientInfo.recipient_email
    this.duration = this.recipientInfo.duration.duration_view
  },
  methods: {
    async confirmEmail() {
      try {
        const responseData = await shareRecordService.saveRecipientInformation(
          this.recipientInfo
        )
        if (responseData.status === 200) {
          this.$emit('confirmEmail')
        }
      } catch (error) {
        console.warn('error:: ', error.response)
        this.snackbarMessage = error.response.data
        this.snackbar = true
      }
    },
    closeDialog() {
      this.$emit('closeDialog', false)
      setTimeout(() => {
        this.selected = null
      }, 500)
    },
    goBack() {
      this.$emit('backClick', false)
    },
  },
}
</script>

<template>
  <v-container class="pa-0">
    <v-card :class="$style.cardClass">
      <v-card-text class="pt-0">
        <!-- close button -->
        <div class="mt-2">
          <div :class="$style.closeButtonDiv">
            <v-btn
              color="offblack"
              :class="$style.closeButton"
              icon
              @click="closeDialog"
              ><v-icon>mdi-close</v-icon></v-btn
            >
          </div>
          <div
            class="pa-4 pl-2 clickable primary--text"
            :class="$style.backRouterLinkText"
            @click="goBack"
          >
            <v-icon color="primary" class="mb-1">mdi-chevron-left</v-icon>Back
          </div>
        </div>

        <!-- card dialog -->
        <template>
          <v-row justify="center" class="pl-4 pr-3">
            <v-col cols="12" md="10" sm="10" class="py-0 mt-10">
              <v-row class="mt-3">
                <p :class="$style.headText"
                  >You are about to share a link to your health records.</p
                >
              </v-row>

              <v-row class="mt-4 py-0 pb-0">
                <p :class="$style.subheadText"
                  >An email invite will be sent to {{ recipientEmail }} with a
                  private link that will expire in <b>24 hours.</b> Your
                  recipient must click on the link and enter your date of birth
                  before viewing your records.<b>
                    They will have access to your records for {{ duration }}.</b
                  ></p
                >
              </v-row>
              <v-row class="mt-3">
                <v-icon left small class="mb-4">mdi-lock </v-icon
                ><p :class="$style.subheadText"
                  >{{ recipientName }} will have read-only access.</p
                >
              </v-row>
              <v-row class="mt-1">
                <v-col>
                  <v-checkbox
                    v-model="termsCheck"
                    hide-details
                    class="shrink mb-1 mt-0"
                    :label="
                      `I am authorized to share this health information under
                    applicable law.`
                    "
                  ></v-checkbox
                ></v-col>
              </v-row>

              <!-- get started button -->
              <v-row no-gutters align="center" justify="center" class="mt-4">
                <v-btn
                  class="mt-2"
                  :class="[
                    'primary-btn',
                    $style.shareButton,
                    !termsCheck && 'disabled-btn',
                  ]"
                  elevation="0"
                  width="236"
                  height="37"
                  @click="confirmEmail"
                  >Share Health Records</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      content-class="body--text"
      height="65"
      color="background"
      :timeout="3000"
    >
      <div class="d-flex">
        <v-icon color="#ee6363" class="my-auto">mdi-close-circle</v-icon>
        <div class="my-auto ml-3">
          {{ snackbarMessage }}
        </div>
      </div>

      <template v-slot:action="{ attrs }">
        <v-btn icon color="body" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.cardClass {
  height: 450px;
  color: #fff;
}
.closeButton {
  position: absolute;
  top: 16px;
  right: 0;
  padding-left: 0;
}
.closeButtonDiv {
  position: relative;
}
.backRouterLinkText {
  position: absolute;
  left: 0;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  color: #0476d9;
  letter-spacing: 0.75px;
}
.headText {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  color: #454648;
}

.subheadText {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  color: #454648;
}

.shareButton {
  align-items: center !important;
  justify-content: center !important;
  width: 350px !important;
  height: 50px !important;
  text-transform: inherit !important;
  background: #0476d9;
  border-radius: 30px;
}

@media screen and (max-width: 1263px) {
  .reviewshareButtonButton {
    top: 490px;
    width: 340px !important;
    height: 50px !important;
  }
}
@media screen and (max-width: 960px) {
  .shareButton {
    top: 490px;
  }
  .headText {
    margin-top: 8px !important;
  }
  .subheadText {
    align-items: center !important;
    margin-left: 0 !important;
  }
  .cardClass {
    height: 1000px;
  }
}
@media screen and (max-width: 599px) {
  .shareButton {
    top: 490px;
    width: 340px !important;
    height: 50px !important;
  }
}
</style>

<style scoped>
/deep/ .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #93c0e8 !important;
}
/deep/ .v-input--selection-controls .v-input__slot > .v-label {
  margin-left: 8px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}
/deep/.v-input--hide-details > .v-input__control > .v-input__slot {
  margin-left: -14px !important;
}
</style>
